import PropTypes from 'prop-types';
import React from 'react';
import {
  ConfigurableImageSelectFormField,
  ConfigurableTextFormField,
  ConfigurableTextSelectFormField,
} from './ConfigurableProductFormField';

const ConfigurableProductForm = ({
  formValues,
  setFormValues,
  steps = [],
}) => (
  <div className="configurable-product__form">
    {
      steps.map((step, index) => {
        const {
          code,
          displayName,
          minLength,
          maxLength,
          options,
          type,
        } = step;
        const key = `configurable-field-${index}`;

        switch (type) {
          case 'text_select':
            return <ConfigurableTextSelectFormField
              code={code}
              displayName={displayName}
              key={key}
              onTextSelectChange={setFormValues}
              options={options}
              value={formValues[code]}/>;
          case 'image_select':
            return <ConfigurableImageSelectFormField
              code={code}
              displayName={displayName}
              key={key}
              onImageSelectChange={setFormValues}
              options={options}
              value={formValues[code]}/>;
          case 'text':
            return <ConfigurableTextFormField
              code={code}
              displayName={displayName}
              key={key}
              minLength={minLength}
              maxLength={maxLength}
              onInputChange={setFormValues}
              value={formValues[code]}/>;
          default:
            return null;
        }
      })
    }
  </div>
);

ConfigurableProductForm.propTypes = {
  formValues: PropTypes.object.isRequired,
  setFormValues: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    code: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    isRequired: PropTypes.bool.isRequired,
    minLength: PropTypes.number.isRequired,
    maxLength: PropTypes.number.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      code: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
    })),
  })),
};

export default ConfigurableProductForm;



// WEBPACK FOOTER //
// ./src/ConfigurableProduct/ConfigurableProductForm.js